import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResult } from '../../../shared/models/paginated-result.model';
import {
  Barcode,
  BarcodeReference,
  BarcodeSearchResult,
  CreateBarcodeRequest,
  Success,
  UpdateBarcodeRequest,
} from '../api.entities';
import { ApiService } from '../api.service';
import { BarcodeQuery, PaginatedBarcodeQuery } from './queries/barcode.query';

@Injectable({
  providedIn: 'root',
})
export class BarcodesApi extends ApiService {
  create(body: CreateBarcodeRequest): Observable<Barcode> {
    return this.request(this.client.POST('/api/barcodes', { body }));
  }

  findAll(query: PaginatedBarcodeQuery): Observable<PaginatedResult<Barcode>> {
    return this.request(this.client.GET('/api/barcodes', { params: { query } }));
  }

  findBarcodeProduct(barcode: string): Observable<BarcodeSearchResult> {
    return this.request(this.client.GET('/api/barcodes/search', { params: { query: { barcode } } }));
  }

  findAllCompact(query?: BarcodeQuery): Observable<BarcodeReference[]> {
    return this.request(this.client.GET('/api/barcodes/compact', { params: { query } }));
  }

  findOne(id: number): Observable<Barcode> {
    return this.request(this.client.GET('/api/barcodes/{id}', { params: { path: { id } } }));
  }

  update(id: number, body: UpdateBarcodeRequest): Observable<Barcode> {
    return this.request(this.client.PATCH('/api/barcodes/{id}', { body, params: { path: { id } } }));
  }

  deleteOne(id: number): Observable<Success> {
    return this.request(this.client.DELETE('/api/barcodes/{id}', { params: { path: { id } } }));
  }
}
